// src/components/Halls/Halls.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { IoHome } from "react-icons/io5";
import { PiKeyReturnFill } from "react-icons/pi";
import { FaPlus, FaTrashAlt, FaEdit } from "react-icons/fa";
import { SiGooglemaps, SiWaze } from "react-icons/si"; // ← הוספה
import { useAuth } from "../../Context/AuthContext";
import HallForm from "./HallForm";
import "./Halls.css";

const API = process.env.REACT_APP_API;

const Halls = () => {
  const navigate = useNavigate();
  const { user, token } = useAuth();

  const [halls, setHalls] = useState([]);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [editingHall, setEditingHall] = useState(null);

  useEffect(() => {
    fetchHalls();
  }, []);

  const fetchHalls = async () => {
    try {
      const res = await axios.get(`${API}/api/halls`);
      setHalls(res.data);
    } catch (err) {
      console.error(err);
      toast.error("שגיאה בטעינת רשימת האולמות");
    }
  };

  const openAddOverlay = () => {
    setEditingHall(null);
    setOverlayOpen(true);
  };

  const openEditOverlay = (hall) => {
    setEditingHall(hall);
    setOverlayOpen(true);
  };

  const handleFormSaved = async () => {
    setOverlayOpen(false);
    await fetchHalls();
  };

  const handleDelete = async (id) => {
    if (window.confirm("האם אתה בטוח שברצונך למחוק את האולם?")) {
      try {
        await axios.delete(`${API}/api/halls/${id}`, {
        headers: {
          "Authorization": `Bearer ${token}`,
        }});
        toast.success("האולם נמחק בהצלחה");
        fetchHalls();
      } catch (err) {
        console.error(err);
        toast.error("שגיאה במחיקת האולם");
      }
    }
  };

  return (
    <div className="halls-container">
      <div className="home-icon">
        <IoHome title="עמוד הבית" size={30} onClick={() => navigate("/")} />
      </div>
      <div className="back-icon">
        <PiKeyReturnFill title="חזרה לעמוד הקודם" size={40} onClick={() => navigate("/leagues")} />
      </div>

      <h2 className="halls-title">האולמות שלנו</h2>

      {user?.isAdmin && (
        <button className="add-hall-btn" onClick={openAddOverlay}>
          <FaPlus /> הוספת אולם חדש
        </button>
      )}

      <div className="halls-list">
        {halls.map((hall) => (
          <div key={hall._id} className="hall-item">
            <div className="hall-details">
              <h2>אולם: {hall.name}</h2>
              <p>ישוב קרוב: {hall.city}</p>
              <div className="map-links">
                {/* Google Maps */}
                <a
                href={hall.googleMapLink}
                target="_blank"
                rel="noopener noreferrer"
                className="map-link google"
                title="פתח ב-Google Maps"
                >
                <SiGooglemaps size={20} /> 
                </a>

                {/* Waze */}
                <a
                href={hall.wazeLink}
                target="_blank"
                rel="noopener noreferrer"
                className="map-link waze"
                title="פתח ב-Waze"
                >
                <SiWaze size={20} />
                </a>
            </div>
            </div>

            {user?.isAdmin && (
              <div className="hall-actions">
                <button onClick={() => openEditOverlay(hall)} className='edit-hall' title="עריכה">
                  <FaEdit />
                </button>
                <button onClick={() => handleDelete(hall._id)} className='delete-hall' title="מחיקה">
                  <FaTrashAlt />
                </button>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Overlay טופס */}
      {overlayOpen && (
        <div className="overlay-bg">
          <div className="overlay-content">
            <div className="overlay-header">
              <h3>{editingHall ? "עריכת אולם" : "הוספת אולם חדש"}</h3>
              <button
                className="close-btn"
                onClick={() => {
                  setOverlayOpen(false);
                  setEditingHall(null);
                }}
              >
                ✖
              </button>
            </div>

            <HallForm
              editingHall={editingHall}
              onSaved={handleFormSaved}
              onCancel={() => {
                setOverlayOpen(false);
                setEditingHall(null);
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Halls;
